import * as types from './types';

export default {
  state: {
    studentList: [],
  },
  getters: {
    [types.STUDENT_LIST]: state => state.studentList,
  },
  mutations: {
    [types.STUDENT_LIST]: (state, payload) => {
      state.studentList = payload.studentList;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/dual-meet/index.js